export default "__VITE_ASSET__MB43Xnts__"